import { Navigate, Route, Routes } from 'react-router-dom';
import { ScreenPermissionGate } from '@/features/access/ui/permission-gate';
import { SetupScreen } from '@/features/access/ui/setup-screen';
import { StaffGate } from '@/features/access/ui/staff-gate';
import { ModerationScreen } from '@/features/admin/ui/moderation-screen';
import { EmailDeliveriesScreen } from '@/features/admin/ui/email-deliveries-screen';
import { OverviewScreen } from '@/features/admin/ui/overview-screen';
import { ReportsScreen } from '@/features/admin/ui/reports-screen';
import { UsersScreen } from '@/features/admin/ui/users-screen';
import { StaffScreen } from '@/features/admin/ui/staff-screen';
import { VerificationQueueScreen } from '@/features/admin/ui/verification-queue-screen';
import { SignInScreen } from '@/features/auth/ui/sign-in-screen';
import { OrganizationDetailScreen } from '@/features/organizations/ui/organization-detail-screen';
import { OrganizationsScreen } from '@/features/organizations/ui/organizations-screen';
import { ReferralCodesScreen } from '@/features/referral-codes/ui/referral-codes-screen';
import { SalesInquiriesScreen } from '@/features/sales/ui/sales-inquiries-screen';
import { AdminShell } from '@/shared/ui';
import { ROUTES } from './routes';

/**
 * ROTA AĞACI.
 *
 * KAPI TEK YERDE: korunan rotaların TAMAMI `StaffGate` + `AdminShell`
 * düzen rotasının ALTINDADIR. Yeni bir ekran eklerken kapıyı ayrıca sarmak
 * gerekmez — dışarıda bir `<Route>` açılırsa `route-gate.guard.spec.tsx`
 * kırılır (kapıyı unutmak mümkün değil).
 *
 * YETKİ KAPISI HER EKRANDA (QA S2/S3 · P2-1): oturum kapısının ALTINDA ikinci
 * bir kapı vardır ve "bu personel bu ekranı kullanabilir mi" sorusunu yanıtlar.
 * Ekran elemanı ÇIPLAK yazılamaz — `screen-permission-coverage.guard.spec.tsx`
 * korunan her `<Route>`un `ScreenPermissionGate` ile sarıldığını sayar, yani
 * kapıyı unutmak mümkün değildir (yeni ekran → kapı yoksa test KIRILIR).
 *
 * KÖK ARTIK EKRANDIR (kullanıcı kararı 2026-09-02 §3): panelin giriş ekranı
 * genel görünüm panosudur. Bilinmeyen adres de köke gider — kapı oturum
 * kararını zaten verir, yani anonim kullanıcı yine girişe düşer ama oturumlu
 * yönetici yanlışlıkla çıkış ekranına atılmaz.
 */
export function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTES.signIn} element={<SignInScreen />} />
      <Route path={ROUTES.setup} element={<SetupScreen />} />
      <Route
        element={
          <StaffGate>
            <AdminShell />
          </StaffGate>
        }
      >
        <Route
          path={ROUTES.home}
          element={
            <ScreenPermissionGate route={ROUTES.home}>
              <OverviewScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.users}
          element={
            <ScreenPermissionGate route={ROUTES.users}>
              <UsersScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.moderation}
          element={
            <ScreenPermissionGate route={ROUTES.moderation}>
              <ModerationScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.reports}
          element={
            <ScreenPermissionGate route={ROUTES.reports}>
              <ReportsScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.verifications}
          element={
            <ScreenPermissionGate route={ROUTES.verifications}>
              <VerificationQueueScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.emailDeliveries}
          element={
            <ScreenPermissionGate route={ROUTES.emailDeliveries}>
              <EmailDeliveriesScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.staff}
          element={
            <ScreenPermissionGate route={ROUTES.staff}>
              <StaffScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.salesInquiries}
          element={
            <ScreenPermissionGate route={ROUTES.salesInquiries}>
              <SalesInquiriesScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.organizations}
          element={
            <ScreenPermissionGate route={ROUTES.organizations}>
              <OrganizationsScreen />
            </ScreenPermissionGate>
          }
        />
        <Route
          path={ROUTES.referralCodes}
          element={
            <ScreenPermissionGate route={ROUTES.referralCodes}>
              <ReferralCodesScreen />
            </ScreenPermissionGate>
          }
        />
        {/*
          Kurum detayı ekran rotası DEĞİLDİR (gezinmede satırı yok, listeden
          açılır) ve kurumlar ekranının yetki kapısını taşır.
        */}
        <Route
          path={ROUTES.organizationDetail}
          element={
            <ScreenPermissionGate route={ROUTES.organizations}>
              <OrganizationDetailScreen />
            </ScreenPermissionGate>
          }
        />
      </Route>
      <Route path="*" element={<Navigate to={ROUTES.home} replace />} />
    </Routes>
  );
}
